ACC.unifiedPDPdataLayer = {

    _autoload: [
    ],

    updateDataLayer(productData) {
        const data = dataLayer[0];
        data.pageInfo.productIsbn = productData.isbn13;
        data.pageInfo.productName = productData.productName;
        let isDefault = false;
        if (data.defaultProduct != null && productData.isbn13 === data.defaultProduct) {
            isDefault = true;
            data.defaultProduct = null;
        }
        dataLayer.push({
            event: 'displayProduct',
            isbn: productData.isbn13,
            isDefault,
        });
    },

    updateDefaultProduct(button) {
        const ecomType = button.getAttribute('id');
        const isbn13 = button.closest('.c-format-list__item').getAttribute('data-first-product');
        const sidebar = $('.format-chooser').children(`[data-product-format=${ecomType}]`);
        if (sidebar.children('.c-sidebar-pdp__sub-format').length > 1) {
            const data = dataLayer[0];
            data.defaultProduct = isbn13;
        }
    },

    pushShowProductOptionsEvent() {
        dataLayer.push({
            event: 'showProductOptions',
        });
    },
};
